import type { HelpConfig } from '#types/config/pages/help'
import type { RecursivePartial } from '#types/utils'

export default {
  showInches: true
} satisfies RecursivePartial<HelpConfig>
